import {EMPHASIS, SplitButton} from '@forecast-it/design-system';
import {BORDER} from '@forecast-it/design-system/dist/forecast-v2/components/controls/buttons/BaseButton';
import React from 'react';
import styled from 'styled-components';

const DateDisplayWithButtonsStyle = styled.div`
	display: flex;
	gap: 4px;
`;

type DateDisplayWithButtonsProps = {
	value: string;
	dataCy?: string;
	onBackButton: () => void;
	onForwardButton: () => void;
};

const DateDisplayWithButtons = ({value, onBackButton, onForwardButton, dataCy}: DateDisplayWithButtonsProps): JSX.Element => {
	return (
		<DateDisplayWithButtonsStyle>
			<SplitButton gap="none">
				<SplitButton.Section
					data-cy={`${dataCy}-back-button`}
					onPress={onBackButton}
					icon={'chevronLeft'}
					emphasis={EMPHASIS.MONO}
				/>
				<SplitButton.Section
					text={value}
					emphasis={EMPHASIS.MONO}
					hasInteractionStyles={false}
					borderRight={BORDER.NONE}
					borderLeft={BORDER.NONE}
				/>
				<SplitButton.Section
					data-cy={`${dataCy}-foward-button`}
					onPress={onForwardButton}
					icon={'chevronRight'}
					emphasis={EMPHASIS.MONO}
				/>
			</SplitButton>
		</DateDisplayWithButtonsStyle>
	);
};

export default DateDisplayWithButtons;
